import React, { useState } from "react";
import DrawerFilter from "../../../../../components/listing/DrawerFilter";
import SelectDepartamento from "../../../../../components/select/SelectDepartamento";

export default function FiltroCiudad({ initialFilters = {}, onSubmit = () => {}, onClose = () => {} }) {
  const [nombre, setNombre] = useState(initialFilters.nombre || "");
  const [codigo, setCodigo] = useState(initialFilters.codigo || "");
  const [nombrePais, setNombrePais] = useState(initialFilters.nombrePais || "");
  const [departamento, setDepartamento] = useState(
    initialFilters.departamentoId
      ? { id: initialFilters.departamentoId, nombre: initialFilters.departamentoNombre || "" }
      : null
  );

  const handleApply = () => {
    onSubmit({
      nombre: nombre.trim(),
      codigo: codigo.trim(),
      nombrePais: nombrePais.trim(),
      departamentoId: departamento?.id ?? undefined,
      departamentoNombre: departamento?.nombre ?? undefined,
    });
    onClose();
  };

  return (
    <DrawerFilter title="Filtros de Ciudades" onClose={onClose} onApply={handleApply}>
      <div className="space-y-4">
        <div>
          <label className="form-label-fil">Nombre:</label>
          <input
            type="text"
            className="input mt-1 w-full"
            value={nombre}
            onChange={(e) => setNombre(e.target.value)}
            placeholder="Buscar por nombre..."
          />
        </div>
        <div>
          <label className="form-label-fil">Código:</label>
          <input
            type="text"
            className="input mt-1 w-full"
            value={codigo}
            onChange={(e) => setCodigo(e.target.value)}
            placeholder="Buscar por código..."
          />
        </div>
        <div>
          <label className="form-label-fil">País:</label>
          <input
            type="text"
            className="input mt-1 w-full"
            value={nombrePais}
            onChange={(e) => setNombrePais(e.target.value)}
            placeholder="Buscar por país..."
          />
        </div>
        <div>
          <label className="form-label-fil">Departamento:</label>
          <SelectDepartamento
            value={departamento}
            onChange={setDepartamento}
            placeholder="Buscar departamento..."
          />
        </div>
      </div>
    </DrawerFilter>
  );
}